import React from 'react';
import Hero from '../components/Hero';
import EventOverview from '../components/EventOverview';
import Footer from '../components/Footer';
import { useSupabaseEvents } from '../hooks/useSupabaseEvents';

export default function HomePage() {
  const { events } = useSupabaseEvents();
  const activeEvents = events.filter((e) => e.isActive !== false);

  return (
    <div className="App">
      <Hero events={activeEvents} />
      {activeEvents.length > 0 ? <EventOverview events={activeEvents} /> : null}
      {activeEvents.length > 0 ? <Footer events={activeEvents} /> : null}
    </div>
  );
}

